module.exports = __webpack_public_path__ + "img/defaultProductIco.f19aaad3.png";